/**
 * dateFormatter.js
 * Talkroute
 *
 * Created by Vel Genov on 3/12/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

import { Moment } from "moment";
import uiString from "../constants/uiString";

/**
 * Get the formatted date and time
 *
 * @param date a moment object representing a date
 * @returns {*} a date and time string formatted in the following format MM/DD/YYYY h:mm:ss a
 */
export const getSimpleFormattedDateAndTime = (date: Moment) => {
  if (date.isValid() === false) {
    return null;
  }

  return date.format("MM/DD/YYYY h:mm:ss a");
};

/**
 * Get the formatted date and time
 *
 * @param date a moment object representing a date
 * @return {*} a date and time string formatted as Today, Yesterday... etc. Time is h:mm:ss
 */
export const getFormattedDateAndTime = (date: Moment) => {
  if (date.isValid() === false) {
    return null;
  }

  return date.calendar(null, {
    sameDay: `[${uiString.daysOfWeek.SAME_DAY}] h:mm a`,
    nextDay: `[${uiString.daysOfWeek.NEXT_DAY}] h:mm a`,
    nextWeek: "dddd h:mm a",
    lastDay: `[${uiString.daysOfWeek.LAST_DAY}] h:mm a`,
    lastWeek: "dddd h:mm a",
    sameElse: "MM/DD/YY h:mm a",
  });
};

/**
 * Get the formatted date
 *
 * @param date a moment object representing a date
 * @return {*} a date and time string formatted as Today, Yesterday... etc.
 */
export const getFormattedDate = (date: Moment) => {
  if (date.isValid() === false) {
    return null;
  }

  return date.calendar(null, {
    sameDay: `h:mm a`,
    nextDay: `[${uiString.daysOfWeek.NEXT_DAY}]`,
    nextWeek: "dddd",
    lastDay: `[${uiString.daysOfWeek.LAST_DAY}]`,
    lastWeek: "dddd",
    sameElse: "MM/DD/YY",
  });
};

/**
 * Get the HH:MM:SS time format from difference of 2 timestamps
 *
 * @param timestamp the difference of 2 timestamps
 */
export const getHHMMSSTime = (timestamp: number) => {
  const sec = Math.floor(timestamp / 1000);
  return `${numFormat(Math.floor(sec / 3600))}:${numFormat(
    Math.floor((sec % 3600) / 60)
  )}:${numFormat(Math.floor(sec % 60))}`;
};

const numFormat = (n) => (n < 10 ? "0" : "") + n;
